Object.defineProperty(exports, '__esModule', { value: true });

var index_module = require('../index.module-e39cc256.js');

var getBorderCorners = function (borderRadius) {
    var _a;
    var bordersSize = typeof borderRadius === 'string'
        ? {
            bottomRight: borderRadius,
            bottomLeft: borderRadius,
            topRight: borderRadius,
            topLeft: borderRadius,
        }
        : borderRadius;
    return (bordersSize && (_a = {},
        _a[index_module.styles["border-bottom-right-".concat(bordersSize.bottomRight)]] = bordersSize.bottomRight,
        _a[index_module.styles["border-bottom-left-".concat(bordersSize.bottomLeft)]] = bordersSize.bottomLeft,
        _a[index_module.styles["border-top-right-".concat(bordersSize.topRight)]] = bordersSize.topRight,
        _a[index_module.styles["border-top-left-".concat(bordersSize.topLeft)]] = bordersSize.topLeft,
        _a));
};

exports.getBorderCorners = getBorderCorners;
